import { RouterSuspenseFallback } from "app/tools/router/components/RouterSuspenseFallback";
import { RouterRoutesSettings } from "app/tools/router/types";
import { Suspense } from "react";
import { Navigate } from "react-router";

import { AuthLayout } from "./Authentication/components/AuthLayout";
import { useAuthTokenContext } from "./Authentication/context";
import { LoginPage } from "./Authentication/pageLogin";

export enum UserRoutes {
  USER_LOGIN = "/login",
}

export const useUserRoutes = (defaultRoute: string): RouterRoutesSettings => {
  const authTokenContext = useAuthTokenContext();

  return {
    public: [
      {
        element: !authTokenContext?.token ? (
          <AuthLayout>
            <Suspense fallback={<RouterSuspenseFallback />}>
              <LoginPage />
            </Suspense>
          </AuthLayout>
        ) : (
          <Navigate replace={true} to={defaultRoute} />
        ),
        path: "login",
      },
    ],
  };
};
